import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';

interface PrivateLoggedRouteProps {
    hasToken: boolean
}

export const PrivateLoggedRoute = ({hasToken}: PrivateLoggedRouteProps) => {

    return hasToken ? <Navigate to="/passport"/> : <Outlet/>;
}